import {
  BUSINESS_APPROVE_REASON,
  BUSINESS_WITH_NULL,
  BUSSINESS,
  BUSSINESS_SIDES,
  BUSSINESS_SUBJECTS,
  BUSSINNESS_CATEGORY,
  SENSITIVE_CONTENT_TYPE,
  SENSITIVE_PIC_TYPE,
  SENSITIVE_WORD_TYPE,
  SENSITIVE_WORDS,
  SUBJECTS,
  USER_GROUPS,
  USER_ID,
  USER_NAME,
  BUSINESS_SOURCE_DATA
} from '../../service/constant'

const state = {
  version: '1.1.1',
  [USER_NAME]: '',
  [USER_ID]: '',
  [USER_GROUPS]: [],
  [SENSITIVE_WORDS]: [],
  [BUSSINESS]: [],
  [SUBJECTS]: [],
  [BUSSINESS_SUBJECTS]: {},
  [BUSSINESS_SIDES]: [],
  [BUSSINNESS_CATEGORY]: {},
  [BUSINESS_APPROVE_REASON]: {},
  [BUSINESS_WITH_NULL]: [],
  [SENSITIVE_CONTENT_TYPE]: [],
  [SENSITIVE_PIC_TYPE]: [],
  [SENSITIVE_WORD_TYPE]: [],
  [BUSINESS_SOURCE_DATA]: {}
}

export default state
